export default "__VITE_ASSET__qEq$6yVn__"